import type { Component } from "solid-js";
import type { IconProps } from "./types";

const RedoIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="m9 15 6 6m0 0 6-6m-6 6V9a6 6 0 0 0-12 0v3" />
    </svg>
  );
};

export default RedoIcon;
